import { api } from "../api";

export const getLeasedDogsByOwner = async (personId: number): Promise<any> => {
  const { data } = await api.get<object>(`/Lease/myleases/${personId}`);

  return data;
};

export default { getLeasedDogsByOwner };
